
<template>
    <div class="center">
      <vs-dialog v-model="active" prevent-close>
        <template #header>
          <h4 class="not-margin">
            Compartir información
          </h4>
        </template>

        <div>
            <md-chips v-model="emails" md-placeholder="Ingrese contactos" :md-auto-insert="true">
                <span class="md-error" v-if="errorFields.includes('emails')">Campo obligatorio</span>
            </md-chips>
            <md-field>
                <label>Asunto</label>
                <md-input v-model="asunto" required></md-input>
                <span class="md-error" v-if="errorFields.includes('emails')">Campo obligatorio</span>
            </md-field>

            <md-field>
                <label>Descripción</label>
                <md-textarea v-model="descripcion" required></md-textarea>
            </md-field>
            <vs-button
                class="ml-auto"
                @click="getEnviarInfo()"
            >
                Enviar
            </vs-button>
        </div>
      </vs-dialog>
    </div>
</template>
<script>
    export default {
        props:[
            'value'
        ],
        data:() => ({
            active: false,
            emails: [],
            asunto: '',
            descripcion: '',
            errorFields: []
        }),
        methods:{
            getEnviarInfo(){
                this.$emit("enviarInfo")
            }
        },
        watch: {
            value (val) {
                this.active = val
            },
            active (val) {
                if (!val){
                    this.$emit('input', val);
                }
            },
        }
    }
  </script>

        